<template>
  <div class="customer container">
      <p class="title">
          <span class="title-text">服务客户<span class="title-line"></span></span>
      </p>
      <div class="customer-list">
          <customer-logo class="logo" v-for="(item, index) in listData" :key="index" :imgdata="item"></customer-logo>
      </div>
  </div>
</template>
<script>
/**
 * 服务客户
 *
 * @requires Home.vue
 * @author liguojie
 */
import CustomerLogo from '@/components/CustomerLogo'
import navApi from '@/http/api/v1/apiNavList'
export default {
  components: {
    CustomerLogo
  },
  name: 'Customer',
  data () {
    return {
      listData: []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () { // 获取客户列表数据
      this.listData = navApi.getCustomerData()
    }
  }
}
</script>

<style scoped lang="scss">
.customer{
    margin-top: 90px;
    .title{
        height: 44px;
        border-bottom: 1px solid #F3F3F8;
        text-align: center;
        .title-text{
            display: inline-block;
            width: 72px;
            height:30px;
            font-size:18px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(33,33,42,1);
            line-height:30px;
            margin-bottom: 14px;
            position: relative;
            .title-line{
                position: absolute;
                bottom: -16px;
                width: 150px;
                height: 3px;
                background:rgba(226,226,232,1);
                left: -39px;
            }
        }
    }
    .customer-list{
        width: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 45px;
        .logo{
            margin-right: 30px;
            margin-bottom: 30px;
        }
        .logo:nth-child(5n){
            margin-right: 0;
        }
    }
}
</style>
